exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-1e1bd708] {\n  font-size: 14px;\n  color: #444;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 15px 0;\n}\n.item[data-v-1e1bd708]:not(:last-child) {\n    border-bottom: 1px solid #ddd;\n}\n.item__title[data-v-1e1bd708] {\n    font-size: 20px;\n}\n.item__title .number[data-v-1e1bd708] {\n      color: #3498db;\n}\n.item__title .status[data-v-1e1bd708] {\n      font-size: 14px;\n      font-weight: bold;\n      margin-left: 20px;\n}\n.item__end .law[data-v-1e1bd708] {\n    cursor: help;\n    border-bottom: 1px dashed #c7c6c6;\n}\n", ""]);

// exports
